/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandThingiverse = createReactComponent(
  "brand-thingiverse",
  "IconBrandThingiverse",
  [
    ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
    ["path", { d: "M8 9h8m-4 0v8", key: "svg-1" }]
  ]
);

export { IconBrandThingiverse as default };
//# sourceMappingURL=IconBrandThingiverse.js.map
